import GuidLookupResourceModel from '../../generated/types/model/resource/GuidLookupResourceModel';

export default class GuidLookupResourceViewModel extends GuidLookupResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
